import BaseEntityModelFilter from "./../../../general/BaseEntityModelFilter";
import store from "./../../../../store";

export default class CategoriesFilter extends BaseEntityModelFilter {
  constructor() {
    super();
    this.setInitialValue();
  }
  setInitialValue() {
    this.setFilterInitialValue();
    this.categoryToken = "";
    this.activationTypeTokens =
      store.getters.generalSetting.categories.activationTypeTokens || [];
  }
  fillData(data) {
    if (data) {
      this.fillFilterData(data);
      this.categoryToken = data.categoryToken ?? "";
      this.activationTypeTokens = data.activationTypeTokens ?? [];
    } else {
      this.setInitialValue();
    }
  }
}
